const GOOGLE_STORAGE_API = 'storage.googleapis.com'

export const toRelativeURL = (url: string) => {
  try {
    const actualURL = new URL(url)

    // if the file uploaded publically
    if (actualURL.host === GOOGLE_STORAGE_API) {
      return url
    }

    const parsedURL = new URL(url, window.location.origin)

    return parsedURL.pathname + parsedURL.search + parsedURL.hash
  } catch {
    return url.startsWith('/') ? url : ''
  }
}
